import { useQuery } from 'react-query';
import request from '../helpers/request';

const getRequestStatuses = async ({ queryKey }) => {
  const [_, forSet] = queryKey;
  const res = await request.get(
    `/Request/statuses${forSet ? '_for_set' : ''}`,
    {},
    'Не удалось загрузить статусы',
    []
  );
  return res;
};

const useRequestStatuses = (options, forSet = false) =>
  useQuery(['states', forSet], getRequestStatuses, options);

export default useRequestStatuses;
